export interface ParallaxPaper {
  el: HTMLElement | null
  factor: number
}

const MAX_SHIFT = 12

/**
 * Papers drift toward the cursor as it moves across the section. Each piece
 * moves by its own share of the max shift (the hero moves the most) for a
 * subtle depth feel. A CSS transition on the elements smooths the chase;
 * transforms reset on mouseleave. No-op when reduced motion is preferred.
 */
export function usePaperParallax(
  sectionRef: Readonly<Ref<HTMLElement | null>>,
  getPapers: () => ParallaxPaper[],
  enabled: Readonly<Ref<boolean>>
) {
  const reducedMotion = usePreferredReducedMotion()
  // useEventListener attaches to this element and detaches when it turns null
  const section = computed(() => (enabled.value && reducedMotion.value !== 'reduce' ? sectionRef.value : null))

  const shiftPapers = (x: number, y: number) => {
    for (const { el, factor } of getPapers()) {
      if (el) el.style.transform = `translate(${x * MAX_SHIFT * 2 * factor}px, ${y * MAX_SHIFT * 2 * factor}px)`
    }
  }

  useEventListener(section, 'mousemove', event => {
    const rect = section.value?.getBoundingClientRect()
    if (!rect) return
    shiftPapers((event.clientX - rect.left) / rect.width - 0.5, (event.clientY - rect.top) / rect.height - 0.5)
  })
  useEventListener(section, 'mouseleave', () => shiftPapers(0, 0))

  watch(section, el => {
    if (!el) shiftPapers(0, 0)
  })
}
